export default [
  {
    path: "/cart",
    name: "Cart",
    component: () => import("@/views/Cart"),
    meta: {
      roles: ["distributor", "customer"],
    },
    children: [
      {
        path: "goodsDetail/:id",
        name: "CartGoodsDetail",
        component: () => import("@/views/GoodsDetail"),
        meta: {
          roles: ["distributor", "customer"],
        },
      },
    ],
  },
];
